import type { ThemeDefinition } from "./types";
import { hexToSrgb, hexToLinear } from "./palette";

export const pacific: ThemeDefinition = {
  label: "Pacific",
  className: "theme-pacific",
  bg: "#081620",
  text: "#80c0d0",
  textMuted: "rgba(128,192,208,0.55)",
  accent: "#c87848",
  glassRgb: "8,22,32",
  border: "rgba(255,255,255,0.08)",
  borderHighlight: "rgba(255,255,255,0.18)",
  separator: "rgba(128,192,208,0.18)",
  selection: "#c87848",
  selectionText: "#081620",
  gridColor: "#80c0d0",
  noiseOpacity: "0.06",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.1), 0 10px 0px rgba(0,0,0,0.55)",
  gpuClear: hexToSrgb("#081620"),
  gpuGridLine: hexToLinear("#80c0d0"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear("#c87848"),
  gpuAxisZ: hexToLinear("#80c0d0"),
  axisXColor: "#c87848",
  axisZColor: "#80c0d0",
  font: '"Space Grotesk", sans-serif',
};
